export default __webpack_public_path__ + "static/media/631.deaaf2f3.png";